import { NextResponse } from 'next/server';
import { clearServerRequests, getServerRequests } from './serverStore';

/**
 * Factory that returns the { GET, DELETE } handlers for the SSR debug bridge.
 *
 * @param options.enabled - When provided, explicitly toggles the route on/off.
 *                          When omitted, falls back to
 *                          `process.env.NODE_ENV === 'development'`.
 */
export function createApiDebuggerRouteHandler(options?: { enabled?: boolean }) {
    const isEnabled = options?.enabled ?? process.env.NODE_ENV === 'development';

    return {
        GET: () => {
            if (!isEnabled) {
                return NextResponse.json({ error: 'Not found' }, { status: 404 });
            }
            return NextResponse.json(getServerRequests(), {
                headers: { 'Cache-Control': 'no-store, no-cache, must-revalidate' },
            });
        },
        DELETE: () => {
            if (!isEnabled) {
                return NextResponse.json({ error: 'Not found' }, { status: 404 });
            }
            clearServerRequests();
            return new NextResponse(null, { status: 204 });
        },
    };
}
